import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-location",
  "use": "icon-location-usage",
  "viewBox": "0 0 23 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 23\" id=\"icon-location\">\n    <path d=\"M11.5 23C5.149 23 0 17.851 0 11.5S5.149 0 11.5 0 23 5.149 23 11.5 17.851 23 11.5 23zm0-2a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19zm0-5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z\" fill=\"currentColor\" fill-rule=\"nonzero\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol